import React, { useEffect, useState } from "react";
import { SearchPage } from "../search-page/search-page";

//TODO Shuffle Data FIRST (Probably do this in the backend)

//Filtering tags by matching selected tags with contractor's specialties

const filterByTags = ( contractors, filter ) => {
  return contractors.map((contractor) => {
    const specialtyArray = [contractor.ppn_primary_specialty, contractor.ppn_secondary_specialty, contractor.ppn_tertiary_specialty, contractor.ppn_quaternary_specialty, contractor.ppn_business_type].filter((x) => !!x);
    const selectedTagsArray = filter.args
    const matchedTags = specialtyArray.filter(specialty => selectedTagsArray.includes(specialty)).map(matchedSpecialty => ({ tag: matchedSpecialty, isMatched: true }))
    const remainingTags = specialtyArray.filter(specialty => !selectedTagsArray.includes(specialty)).map(unmatchedSpecialty => ({ tag: unmatchedSpecialty, isMatched: false }))
    const detailedTags = [...matchedTags, ...remainingTags]
    contractor.detailedTags = detailedTags.filter(x => !!x.tag)
    // ensure all contractors are returned when the tags are empty
    return (matchedTags.length || (filter.type === 'tags' && !filter.args.length) ? contractor : null)
  }).filter(x => !!x)
}

// show selected star-rating and higher rating results 
const filterByRating = ( contractors, filter ) => {
  return contractors.filter( contractor => contractor.rating >= filter.args )
}

//both 'contractor.number_completed_projects' and 'filter.args' are strings
const filterByJobsCompleted = ( contractors, filter ) => {
  return contractors.filter( contractor => parseInt(contractor.number_completed_projects) >= parseInt(filter.args) )
}

// TODO Make this functionality correct
const filterByName = ( contractors, filter ) => {
  return contractors.filter( contractor => contractor.company_name.includes(filter.args) );
}

const filterByDistance = ( contractors, filter ) => {
  return contractors.filter( contractor => contractor.distance <= filter.args )
}

const sortByLocation = ( contractors, filter ) => {
  return contractors.sort((a, b) => a.distance - b.distance)
}

// These values map to the functions above

const filterMap = {
  tags: filterByTags,
  rating: filterByRating,
  completed: filterByJobsCompleted,
  name: filterByName,
  distance: filterByDistance,
  location: sortByLocation
}

// This function takes the list of contractors, and the array of filter objects.
// It then uses filter map to determine which functions should run to filter the
// contractors list.

const applyFilters = (contractors, filters) => {
  let filterResults = contractors

  // include empty tags args when tags are removed to ensure they are not matched on the contractor cards
  let updatedFilters = filters.filter(e => e.type === 'tags').length > 0 ? filters : [...[{type: "tags", args: []}], ...filters]
  updatedFilters.forEach(( filter ) => {

    Object.entries(filterMap).forEach(([k,v]) => {
      if (filter.type === k) filterResults = v(filterResults, filter)
    })
  })

  //FILTER CONTRACTORS CLOSEST TO SEARCH LOCATION BY DEFAULT************
  filterResults.sort((a, b) => (a.distance || Infinity) - (b.distance || Infinity));

  return filterResults
}


// searchFunction component 
export const SearchFunction = ( {contractors, handleLocation, user, fullContractorList, filters, setFilters} ) => {

  const [ filteredContractors, setFilteredContractors ] = useState([]);


  // Re-render on filters added or contractor data updated
  useEffect(() => {
    setFilteredContractors(applyFilters(contractors, filters));

  }, [filters, contractors ]);



  // Returns a new filter list with {filter} added
  const addFilter = ( filter, filterList ) => [...filterList, filter]

  // Returns a new filter list with {filter} removed
  const removeFilter = ( filter, filterList ) => filterList.filter( existing  => existing.type !== filter.type )

  //Returns true if filter exists
  const filterExists = ( filter, filterList) => filterList.some( existing => existing.type === filter.type )

  // This callback handles filters that are not toggles but instead
  // if the filter exists remove it, and add the new filter to the list
  // else just add the new filter to the stack if there are "args:"
  // also the optional second parameter accepts a string of a type name and will remove it from the filter

  const handleFilters = ( filterArr, clearFilterType ) => {
    // Get the current filters in state
    let currentFilters = filters

    filterArr.forEach((f) => {
      if (filterExists(f, currentFilters)) {
        currentFilters = removeFilter(f, currentFilters)
      }
      // f.args could be a number (starRating, distance)
      if (f.args.length > 0 || f.args > 0) {
        currentFilters = addFilter(f, currentFilters)
      }
    })

    // remove filter if its type param is provided
    if (typeof(clearFilterType) !== 'undefined') {
      currentFilters.forEach((f) => {
        if (filterExists(f, currentFilters) && f.type === clearFilterType) {
          currentFilters = removeFilter(f, currentFilters)
        }
      })
    }
    setFilters(currentFilters)
  }

  return (
    <SearchPage contractors={ filteredContractors } fullContractorList={fullContractorList} handleFilters = { handleFilters } handleLocation = { handleLocation } user={user} />
  )
}
